import { IFormField } from "src/types/form.types"
import { TextField } from "./FormFields/TextField";
import {PasswordField} from "./FormFields/PasswordField";
import { SelectField } from "./FormFields/SelectField";

type Props=IFormField & {
    errors:any;
    control:any
}
export const FormField=(props:Props)=>{
    const {type} =props
    if(type=== "email") {
        return <TextField {...props}></TextField>
    }
    if( type==="password") {
        return <PasswordField {...props}></PasswordField>
    }
    if(type==="select") {
        return <SelectField {...props}></SelectField>
    }
    return null
}